<app-page>
  <manage-follows></manage-follows>
</app-page>
